import { inject, Pipe, PipeTransform } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { WorkerNameService } from './worker-name.service';

@Pipe({ name: 'workerName' })
export class WorkerNamePipe implements PipeTransform {
  private workerNameService = inject(WorkerNameService);

  transform(value: string | null | undefined): Observable<string> {
    if (value === null || value === undefined) {
      return of('');
    }
    return this.workerNameService
      .getNameMap([value.trim()])
      .pipe(
        map(
          (workerMap) => workerMap[value.trim()],
        ),
      );
  }
}
